/*================ Variables ================*/
import 'global/variables';

/*================ Vendor ================*/
import 'select2';
import { TweenMax, TimelineMax } from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!vendor/scrollmagic-animation.gsap.min';
import Plyr from 'plyr';
import 'parsleyjs';
import tippy from 'tippy.js';
import { debounce } from 'lodash';

/*================ Slate ================*/
import 'slate/a11y';
import 'slate/cart';
import 'slate/utils';
import 'slate/rte';
import 'slate/sections';
import 'slate/currency';
import 'slate/images';
import 'slate/variants';

/*================ Sections ================*/
import 'sections/product';

/*================ Templates ================*/
import 'templates/customers-addresses';
import 'templates/customers-login';
import 'templates/wall-art';

/*================ Common ================*/
// import 'common/constant';

/*================ Customs ================*/
// Utils
require('custom/utils');
require('custom/algolia-utils');
require('custom/algolia-widget-builder');
require('custom/algolia-search-insights');
require('custom/shopify-api');
// Components
require('custom/navigation');
require('custom/nav-active-link');
require('custom/form-numbers');
require('custom/form-select');
require('custom/form-checkbox');
require('custom/form-file-upload');
require('custom/accordion');
require('custom/product-scroll');
require('custom/variant-dropdown');
require('custom/variant-sort');
require('custom/pdp-carousel');
require('custom/pdp-thumbnails');
require('custom/pdp-collection-carousel');
require('custom/pdp-variant-select');
require('custom/pdp-rug-driver');
require('custom/pdp-custom-contents');
require('custom/pdp-magnifier');
require('custom/in-viewport');
require('custom/product-card-hover');
require('custom/collection-card');
require('custom/similar-collections');
require('custom/similar-products');
require('custom/alternative-products');
require('custom/algolia-search');
require('custom/filter-dropdown');
require('custom/form-label-animation');
require('custom/forgot-password');
require('custom/search-panel');
require('custom/quick-panel');
require('custom/bodyclass-toggle');
require('custom/products-in-collection');
require('custom/type-design-id');
require('custom/gallery');
require('custom/load-more-article');
require('custom/load-more-cards');
require('custom/lazy-swap');
require('custom/lazy-images');
require('custom/simple-form-handler');
require('custom/form-action-handler');
require('custom/login-form-handler');
require('custom/sticky-scroll');
require('custom/fixed-scroll');
require('custom/subscribe-form');
require('custom/inline-sync-carousel');
require('custom/project-index-carousel');
require('custom/class-handler');
require('magnific-popup');
require('custom/video-autoplay-handler');
require('custom/photo-downloads');
require('custom/scroll-direction');
require('custom/scroll-to');
require('custom/radio-ui-switcher');
require('custom/multi-step-form');
require('custom/become-a-dealer');
require('custom/google-shopping-search');
require('custom/account-active-tab');
require('custom/existing-user-form');
require('custom/auto-carousel');
require('custom/current-refinements-position');
require('custom/dropdown-to-radio');
require('custom/css-vh-update');
require('custom/inventory-panel-sort');
require('custom/project-carousel');

// Return Form
require('custom/return-form');

// Restock Date
require('custom/restock-date');

// Request Access form Handler
require('custom/request-access-submission');

// Google Tag Manager
require('custom/gtm-handler');
// Optimizely Events
require('custom/optimizely-handler');

/*================ Modernizr Check ================*/
const html = document.querySelector('html');
html.classList.remove('no-js');
html.classList.add('js');
function is_touch_enabled() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}
window.touchDevice = is_touch_enabled();

/*================ Account ================*/
import * as account from 'account/index';
require('account/recent-orders');

/*=========== Styles (for tailwind) ===========*/
import styles from 'styles/theme.scss';

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        'supports-no-cookies',
        'supports-cookies',
      );
  }

  /**
   * Google Tag Manager
   */
  custom.gtmHandler.init();
  custom.optimizelyHandler.init();
  custom.lazyImages.init();

  /**
   * Algolia Search Insights
   */
  custom.algoliaSearchInsights.init();

  // Parsley
  if ($('.js-parsley')) $('.js-parsley').parsley();
  custom.utils.parsleyCustomValidator();
  window.Parsley.on('form:error', function () {
    const scrollDownClass = 'js-scroll-direction-down';
    const scrollUpClass = 'js-scroll-direction-up';
    const scrollTopClass = 'js-scroll-window-top';
    // remove scroll up class for firefox
    // delay to fire after scroll direction src/scripts/src/custom/scroll-direction.js
    setTimeout(() => {
      document.body.classList.remove(scrollUpClass);
      document.body.classList.remove(scrollTopClass);
      document.body.classList.add(scrollDownClass);
    }, '250');
  });

  // Title-casing
  if ($('.js-titlecase'))
    $('.js-titlecase').each((index, el) => {
      $(el).text(custom.utils.titleCase($(el).text()));
    });

  /**
   * General Interface
   */
  custom.navActiveLink.init(); // Active link in navigation
  custom.FormNumbers.init(); // Custom Quantity change
  custom.formSelect.init(); // Custom style selector with Select2
  custom.typeDesignId.init(); // Product title styling
  custom.Accordion.init(); // Accordion
  custom.scrollTo.init(); // ScrollTo animation
  custom.variantDropdown.init();
  custom.dropdownToRadio.init();
  custom.currentRefinementsPosition.init();
  custom.cssVhUpdate.init();
  $(window).on('load', () => {
    setTimeout(custom.formLabelAnimation.init, 1000);
  });
  custom.utils.initCountryProvinceSelector();

  /**
   * Tooltip
   */
  tippy('.js-tippy', {
    animation: 'fade',
    appendTo: document.body,
    arrow: true,
    arrowTransform: 'scaleX(0.75)',
    placement: 'top',
    maxWidth: '238px',
    maxHeight: '81px',
    touchHold: false,
    interactive: true,
  });

  function isMobile() {
    return $(window).width() < 768;
  }

  if (isMobile()) {
    tippy('.js-tippy-map', {
      animation: 'fade',
      appendTo: document.body,
      arrow: true,
      arrowTransform: 'scaleX(0.75)',
      placement: 'top',
      maxWidth: '238px',
      offset: '62, 0',
      maxHeight: '81px',
      interactive: true,
    });
  } else {
    tippy('.js-tippy-map', {
      animation: 'fade',
      appendTo: document.body,
      arrow: true,
      arrowTransform: 'scaleX(0.75)',
      placement: 'top',
      maxWidth: '238px',
      maxHeight: '81px',
      interactive: true,
    });
  }

  /**
   * Page Specific
   */
  custom.pdpCarousel.init();
  if ($('.js-pdp-collection-carousel').length)
    custom.pdpCollectionCarousel.init();
  custom.pdpCustomContents.init();
  if ($('.js-rug-pad-driver').length) custom.pdpRugDriver.init();
  if (!$('.template-cart').length) custom.restockDate.init();
  custom.projectIndexCarousel.init();
  custom.inlineSyncCarousel.init();
  // custom.collectionCard.init();
  custom.navigation.init();
  custom.simpleFormHandler.init();
  custom.formActionHandler.init();
  custom.loginFormHandler.init();

  custom.multiStepForm.init();
  custom.becomeADealer.init();
  custom.existingUserForm.init();
  custom.googleShoppingSearch.init();
  //custom.formLabelAnimation.init();
  custom.requestAccessSubmission.init();
  $(window).on('load', custom.photoDownloads.init);
  custom.accountActiveTab.init();

  // Custom Checkout Thankyou Page - Mobile View Order Toggle Functionality
  if ($('body').hasClass('page-checkout-thank-you')) {
    const showOrder = 'Show order summary';
    const hideOrder = 'Hide order summary';
    const collapsedClass = 'order-summary--is-collapsed';
    const expandedClass = 'order-summary--is-expanded';
    const $orderSummary = $('.order-summary');
    const $arrowDown = $('#arrow-down');
    const $arrowUp = $('#arrow-up');

    //Remove Billing and shipping IDs in session storage used for maintaining address dropdown values in checkout.
    sessionStorage.removeItem('lastPaymentID');
    sessionStorage.removeItem('lastShippingID');
    sessionStorage.removeItem('shippingSaveValue');
    sessionStorage.removeItem('billingSaveValue');

    let summaryExpanded = $('.order-summary-toggle__text--show span')
      .text()
      .includes(showOrder)
      ? false
      : true;

    $('.order-summary-toggle').on('click', function () {
      if (summaryExpanded) {
        $('.order-summary-toggle__text--show span').text(showOrder);
        $orderSummary.addClass(collapsedClass);
        $orderSummary.removeClass(expandedClass);
        $arrowDown.show();
        $arrowUp.hide();
        summaryExpanded = false;
      } else {
        $('.order-summary-toggle__text--show span').text(hideOrder);
        $orderSummary.addClass(expandedClass);
        $orderSummary.removeClass(collapsedClass);
        $arrowDown.hide();
        $arrowUp.show();
        summaryExpanded = true;
      }
    });
  }

  if (
    $('body').hasClass('page-collaboration') ||
    $('body').hasClass('page-virtual-market') ||
    $('body').hasClass('page-home')
  ) {
    //see if any video modals
    //https://github.com/sampotts/plyr
    //https://dimsemenov.com/plugins/magnific-popup/documentation.html#api
    //https://github.com/sampotts/plyr/issues/495
    var vidplayers;
    $('.js-video-modal').magnificPopup({
      type: 'inline',
      removalDelay: 500,
      mainClass: 'mfp-zoom-in mfp-video',
      gallery: {
        enabled: false,
      },
      callbacks: {
        open: function () {
          var id = $(this)[0].currItem.src;
          vidplayers = Plyr.setup(id + ' .js-player-modal', {
            autoplay: true,
            playsinline: true,
            fullscreen: {
              iosNative: true,
            },
            controls: [
              'play',
              'progress',
              'current-time',
              'mute',
              'volume',
              'captions',
              'fullscreen',
            ],
          });
        },
        close: function () {
          vidplayers[0].pause();
          vidplayers[0].destroy();
        },
      },
    });
  }

  // Collection card initialization
  window.pubsub.on('hasRenderedCollectionCard', (handle) =>
    custom.collectionCard.init(handle),
  );

  // Pillow Card Hover Interaction
  custom.productCardPillow.init();

  // Same Products in Collection on PDP
  if ($('.js-products-in-collection').length > 0)
    custom.productsInCollection.init();

  // Sticky Scroll
  custom.stickyScroll.init();

  // Wall Art Fixed Scroll Container
  custom.fixedScroll.init();

  // Wall Art Carousel
  if ($('.js-auto-carousel').length > 0) custom.autoCarousel.init();

  // Projects Carousel
  if ($('.js-projects-carousel').length > 0) custom.projectsCarousel.init();

  if ($('.js-standard-carousel').length > 0) {
    const $carousel = $('.js-standard-carousel').slick({
      infinite: false,
      dots: true,
      arrows: false,
    });
    $('.js-standard-carousel .slick-slide').on('click', () => {
      $carousel.slick('slickNext');
    });
  }
  if ($('.js-fade-carousel').length > 0) {
    $('.js-fade-carousel').slick({
      infinite: true,
      dots: false,
      arrows: false,
      fade: true,
      autoplay: true,
      easing: 'ease-in-out',
      speed: 1000,
      autoplaySpeed: 7000,
    });
  }

  //CARD CAROUSELS
  const cardCarouselDefaults = {
    infinite: false,
    dots: true,
    arrows: true,
    dotsClass: 'card-carousel__dots',
  };

  //ADD MAGIC MOUSE or MOUSE WHEEL SUPPORT - https://stackoverflow.com/questions/46508975/how-to-use-mouse-scroll-instead-of-drag-in-slick-js
  function slickWheel(e, carousel) {
    let deltaX = e.originalEvent.deltaX;

    if (typeof deltaX != 'undefined') {
      clearTimeout(carousel.blockTimeout);
      carousel.blockTimeout = setTimeout(function () {
        carousel.blocked = false;
      }, 50);

      if (
        (deltaX > 10 && deltaX > carousel.prevDeltaX) ||
        (deltaX < -10 && deltaX < carousel.prevDeltaX) ||
        !carousel.blocked
      ) {
        e.preventDefault();
        e.stopPropagation();

        carousel.blocked = true;
        carousel.prevDeltaX = deltaX;

        if (deltaX > 0) {
          carousel.slick('slickNext');
        } else {
          carousel.slick('slickPrev');
        }
      }
    }
  }

  // Shop by Category Carousel
  if ($('.js-category-carousel').length > 0) {
    const categoryCarousel = $('.js-category-carousel').slick({
      ...cardCarouselDefaults,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendDots: $('.js-category-carousel-dots'),
      prevArrow: '.js-category-carousel-arrows-prev',
      nextArrow: '.js-category-carousel-arrows-next',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
    categoryCarousel.blocked = false;
    categoryCarousel.blockTimeout = null;
    categoryCarousel.prevDeltaX = null;
    categoryCarousel.on('mousewheel DOMMouseScroll wheel', function (e) {
      slickWheel(e, categoryCarousel);
    });
  }

  // Product Carousel
  if ($('.js-product-carousel').length > 0) {
    const productCarousel = $('.js-product-carousel').slick({
      ...cardCarouselDefaults,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendDots: $('.js-product-carousel-dots'),
      prevArrow: '.js-product-carousel-arrows-prev',
      nextArrow: '.js-product-carousel-arrows-next',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
    productCarousel.blocked = false;
    productCarousel.blockTimeout = null;
    productCarousel.prevDeltaX = null;
    productCarousel.on('mousewheel DOMMouseScroll wheel', function (e) {
      slickWheel(e, productCarousel);
    });
  }

  // Project Drivers Carousel
  if ($('.js-project-drivers-carousel').length > 0) {
    //https://stackoverflow.com/a/63501839 - to hide slick on desktop
    var projectDriverSliderElem = $('.js-project-drivers-carousel'),
      projectDriverSliderBool = false,
      projectDriverSliderBreakpoint = 1024,
      projectDriverSliderSettings = {
        ...cardCarouselDefaults,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $('.js-project-drivers-carousel-dots'),
        prevArrow: '.js-project-drivers-carousel-arrows-prev',
        nextArrow: '.js-project-drivers-carousel-arrows-next',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: projectDriverSliderBreakpoint,
            settings: 'unslick',
          },
        ],
      };
    function projectDriverSliderInit() {
      if (window.innerWidth <= projectDriverSliderBreakpoint) {
        if (projectDriverSliderBool == false) {
          projectDriverSliderElem.slick(projectDriverSliderSettings);
          projectDriverSliderElem.blocked = false;
          projectDriverSliderElem.blockTimeout = null;
          projectDriverSliderElem.prevDeltaX = null;
          projectDriverSliderElem.on(
            'mousewheel DOMMouseScroll wheel',
            function (e) {
              slickWheel(e, projectDriverSliderElem);
            },
          );
          projectDriverSliderBool = true;
        }
      } else {
        projectDriverSliderBool = false;
      }
    }
    // resize
    $(window).on(
      'resize',
      debounce(function () {
        projectDriverSliderInit();
      }, 100),
    );
    projectDriverSliderInit();
  }

  // Slider Tabs
  if ($('.slider-tabs').length > 0) {
    function handleTabChange(tab) {
      var tabContainer = tab.closest('.slider-tabs');
      var tabListContainer = tab.closest('.slider-tabs__tabs');
      //set indicator size and position
      $('.slider-tabs__indicator', tabListContainer).css({
        width: tab.outerWidth(),
        left: tab.position().left,
      });
      //deselect all tabs
      tab
        .siblings()
        .removeClass('active content-default content-subtle')
        .addClass('content-subtle')
        .attr('aria-selected', 'false');
      //select clicked tab
      tab
        .removeClass('content-subtle')
        .addClass('active content-default')
        .attr('aria-selected', 'true');
      //hide all panels
      tabContainer.find('div[role="tabpanel"]').attr('hidden', 'true');
      //show panel
      $(`#${tab.attr('aria-controls')}`).removeAttr('hidden');
    }

    $(document).on('click', '.slider-tabs .slider-tabs__link', function () {
      handleTabChange($(this));
    });

    handleTabChange($('.slider-tabs .active'));

    // resize
    $(window).on(
      'resize',
      debounce(function () {
        handleTabChange($('.slider-tabs .active'));
      }, 100),
    );
  }

  // Continue Browsing Carousel
  if ($('.js-continue-browsing-carousel').length > 0) {
    const desktopSlides = $('.js-continue-browsing-carousel').data(
      'desktop-slides',
    );
    const continueBrowsingCarousel = $('.js-continue-browsing-carousel').slick({
      ...cardCarouselDefaults,
      slidesToShow: desktopSlides,
      slidesToScroll: 1,
      appendDots: $('.js-continue-browsing-carousel-dots'),
      prevArrow: '.js-continue-browsing-carousel-arrows-prev',
      nextArrow: '.js-continue-browsing-carousel-arrows-next',
      responsive: [
        {
          breakpoint: 1320,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
    continueBrowsingCarousel.blocked = false;
    continueBrowsingCarousel.blockTimeout = null;
    continueBrowsingCarousel.prevDeltaX = null;
    continueBrowsingCarousel.on(
      'mousewheel DOMMouseScroll wheel',
      function (e) {
        slickWheel(e, continueBrowsingCarousel);
      },
    );
  }

  // Recent Orders
  custom.recentOrders.init();

  //if logged in and on PDP page, save it
  if (
    window.MUAPP.common.Shopify.customer &&
    window.MUAPP.common.Shopify.customer.id &&
    window.location.pathname.indexOf('/products/') >= 0
  ) {
    const handle = window.location.pathname.split('/').pop();
    custom.recentOrders.store(handle);
  }

  // Video Component
  if ($('.js-player').length > 0) {
    var checkJSPlayerInit = function () {
      if ($('.js-player').not('.js-player--loaded').length > 0) {
        $('.js-player').each(function (index) {
          //check scroll distance of each player
          const scrollTop = $(window).scrollTop(),
            windowHeight = $(window).height(),
            elem = $(this).offset().top,
            final = elem - windowHeight,
            distance = final - scrollTop;
          //initialize playerif within 100px
          if (distance < 500) {
            $(this).addClass('js-player--loaded');
            const thisPlayer = new Plyr(this, {
              controls: [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'captions',
                'fullscreen',
              ],
              playsinline: true,
              fullscreen: {
                container: null,
                iosNative: true,
              },
            });
            thisPlayer.on('enterfullscreen', () => {
              $('body.page-highpoint').addClass('js-scroll-window-top');
            });
            if ($('.js-player').not('.js-player--loaded').length <= 0) {
              $(window).off('scroll', checkJSPlayerInit);
            }
          }
        });
      } else {
        $(window).off('scroll', checkJSPlayerInit);
      }
    };
    checkJSPlayerInit();
    $(window).scroll(checkJSPlayerInit);
  }
  /**
   * QUICK VIEW MEDIATION
   */

  // Quick View on open handler
  custom.quickView.on('quick-panel-inventory-loaded', () => {
    custom.FormNumbers.init();
    custom.restockDate.init();
    custom.gtmHandler.init();
    custom.optimizelyHandler.init();
    custom.loginFormHandler.init();
  });

  custom.quickView.on('open', () => {
    // Initialize custom form numbers
    custom.variantDropdown.init();
    custom.FormNumbers.init();
    custom.simpleFormHandler.init();
    custom.typeDesignId.init();
    custom.googleShoppingSearch.init();
    custom.gtmHandler.init();
    custom.optimizelyHandler.init();
  });

  /**
   * IN VIEWPORT MEDIATION
   */
  custom.inViewport.on('in', custom.videoAutoplayHandler.play);

  /**
   * RESTOCK DATE MEDIATION
   */
  custom.restockDate.on('return-date', ({ date, sku, dateUnformatted }) => {
    $(`[data-sku="${sku}"]`).text(date).data('eta', dateUnformatted);
  });

  /**
   * Become A Dealer Submission
   */
  //window.pubsub.on('hasMultiFromValidated', custom.becomeADealer.triggerSubmission);
  window.pubsub.on('hasMultiFromValidated', () => {
    grecaptcha.execute();
  });

  /**
   * Account Info Rendered/Updated
   */
  window.pubsub.on(
    'updatedCountryValue',
    custom.formSelect.shopifyCountrySelectorInit,
  );
  window.pubsub.on(
    'updatedProvinceValue',
    custom.formSelect.provinceValueSetter,
  );

  /**
   * Order History Rendered
   */
  window.pubsub.on('orderHistoryRendered', () => {
    custom.typeDesignId.init();
    custom.gtmHandler.init();
  });

  /**
   * Order Detail Rendered
   */
  window.pubsub.on('orderDetailRendered', () => {
    custom.typeDesignId.init();
    custom.gtmHandler.init();
    tippy('.js-tippy', {
      animation: 'fade',
      appendTo: document.body,
      arrow: true,
      arrowTransform: 'scaleX(0.75)',
      placement: 'top',
      maxWidth: '238px',
      maxHeight: '81px',
      touchHold: false,
      interactive: true,
    });
  });

  window.pubsub.on('openAutoCompleteRedrawn', () => {
    custom.typeDesignId.init();
    custom.lazyImages.init();
    custom.gtmHandler.init();
  });

  /**
   * Return Form Initialization
   */
  if ($('.js-return-order').length) {
    if ($('.js-return-order--netsuite').length) {
      custom.returnForm.init();
    } else {
      window.pubsub.on('returnDetailRendered', custom.returnForm.init);
    }
  }

  /**
   * Forgot Password Ajax Submission
   */
  custom.forgotPassword.init();

  /**
   * MUAPP Initialization
   *
   */
  account.init();

  /**
   * Faceted search clear-all
   */
  $('body').on('click', '.ais-current-refined-values--clear-all', function () {
    window.pubsub.trigger('clearAllClicked');
  });

  /* Highpoint Forms */
  const switcherClass = 'js-highpoint-form-switcher';
  $('body').on('click', `.${switcherClass}`, function (e) {
    $.magnificPopup.close();
    const form = $(e.target).attr('href');
    $.magnificPopup.open({
      items: {
        src: form,
      },
      type: 'inline',
    });
  });

  custom.loginFormHandler.inputPopupHandler('vegas-appointment');
  custom.loginFormHandler.inputPopupHandler('vegas-virtual-appointment');
  custom.loginFormHandler.inputPopupHandler('vegas-email');
  custom.loginFormHandler.inputPopupHandler('vegas-emailconsumer');
  custom.loginFormHandler.inputPopupHandler('appointment');
  custom.loginFormHandler.inputPopupHandler('virtual-appointment');
  custom.loginFormHandler.inputPopupHandler('email');
  custom.loginFormHandler.inputPopupHandler('emailconsumer');
  let highpointFormIds = [
    'VegasForm',
    'VegasVirtualForm',
    'VegasEmailForm',
    'VegasEmailConsumerForm',
    'HighpointForm',
    'HighpointVirtualForm',
    'HighpointEmailForm',
    'HighpointEmailConsumerForm',
  ];
  for (let i = 0; i < highpointFormIds.length; i++) {
    $(`#${highpointFormIds[i]} button[type="submit"]`).on(
      'click',
      function (e) {
        e.preventDefault();
        custom.simpleFormHandler.formSubmission($(`#${highpointFormIds[i]}`));
      },
    );
    $(`#${highpointFormIds[i]} input, #${highpointFormIds[i]} select`)
      .on('keyup change', function (e) {
        checkRequiredFields(e);
        floatingLabel(e);
      })
      .trigger('keyup change');
  }
  $('.form .field__input')
    .on('keyup change', function (e) {
      floatingLabel(e);
    })
    .trigger('keyup change');

  $('.checkbox-text').on('click', function (e) {
    $(e.target).siblings('input').click();
  });
  // for text areas as you scroll need to hide the label
  $('.field__input--textarea').on('scroll', function () {
    const container = $(this).closest('.field.field--show-floating-label');
    if ($(this).scrollTop() > 5) {
      container.addClass('field__input--textarea-label-hide');
    } else {
      container.removeClass('field__input--textarea-label-hide');
    }
  });
  function floatingLabel(e) {
    if (!e) return;
    if ($(e.target).val() == '') {
      $(e.target)
        .closest('.field.field--show-floating-label')
        .removeClass('field__label--visible');
    } else {
      $(e.target)
        .closest('.field.field--show-floating-label')
        .addClass('field__label--visible');
    }
  }
  function checkRequiredFields(e) {
    if (!e) return;
    const formID = $(e.target).closest('form').attr('id');
    if (!formID) return;
    let filledRequired = 0;
    let numberOfFields = $(
      `#${formID} input:required, #${formID} select:required`,
    ).length;
    const $fields = $(`#${formID} input:required, #${formID} select:required`);
    for (let i = 0; i < $fields.length; i++) {
      filledRequired =
        $($fields[i]).val() != '' && $($fields[i]).val() != null
          ? (filledRequired += 1)
          : (filledRequired += 0);
    }
    let allFilled = numberOfFields <= filledRequired;
    return allFilled
      ? $(`#${formID} button`).prop('disabled', false)
      : $(`#${formID} button`).prop('disabled', true);
  }
  var hpHeroVideoOptions = {
    controls: [],
    playsinline: true,
    autoplay: true,
    loop: {
      active: true,
    },
    autopause: false,
    muted: true,
    clickToPlay: false,
    fullscreen: {
      enabled: false,
    },
  };
  const hpMobilePlayer = new Plyr(
    '.js-player-highpoint-hero-mobile',
    hpHeroVideoOptions,
  );
  const hpDesktopPlayer = new Plyr(
    '.js-player-highpoint-hero',
    hpHeroVideoOptions,
  );
  /* END Highpoint Forms */

  // for mobile fixed cta's we want to fade them in as user scrolls down viewport
  if (isMobile()) {
    function mobileFixedDelay() {
      if ($(window).scrollTop() > 100) {
        $('.js-mobile-fixed-delay')
          .removeClass('fade-out-fixed')
          .addClass('fade-in-fixed');
      } else {
        if ($('.js-mobile-fixed-delay').hasClass('fade-in-fixed')) {
          $('.js-mobile-fixed-delay')
            .removeClass('fade-in-fixed')
            .addClass('fade-out-fixed');
        }
      }
    }
    if ($('.js-mobile-fixed-delay').length > 0) {
      //debounce window scroll, once scroll down 100px, fade in cta
      $(window).on(
        'scroll',
        debounce(function () {
          mobileFixedDelay();
        }, 100),
      );
      mobileFixedDelay();
    }
  }
});

const $inStockEl = $('.js-in-stock');
window.pubsub.on('clearAllClicked', () => {
  if ($inStockEl.prop('checked') === true) {
    //Timeout required to prevent race issue causing two sets of results to render
    setTimeout(function () {
      $inStockEl.click();
    }, 100);
  }
  //Remove no results message if it exists.
  $('.searchResults__no-results').remove();
});

document.addEventListener('DOMContentLoaded', () => {
  custom.inViewport.init();
  custom.inViewport.objectFitFallback();
  theme.wallArt.init();
});



// WEBPACK FOOTER //
// ./src/scripts/src/theme.jsx